import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  SUBCOMMITTEE_LIST,
  SUBCOMMITTEE_EVENT_NOTICE_LIST,
  API_URL_ORGANIZER_SUBCOMMITTEE,
} from 'manager/http-constants';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { PlatformComponent } from '../platform.component';

@Component({
  selector: 'app-e201',
  templateUrl: './e201.component.html',
  styleUrls: ['./e201.component.scss', '../platform.component.scss'],
})

/**
 * 分科会一覧
 */
export class E201Component extends PlatformComponent {
  // 分科会一覧格納先
  subcommitteeDataList: any[] = new Array();

  // 分科会,イベントのお知らせ一覧格納先
  noticeList: any;

  // 主催/参加分科会一覧格納先
  organizerSubcommitteeList: any;

  // 表示区分
  information_kbn: string;

  // ログイン判定
  isLogin: boolean;

  // 当年度
  currentYear: number;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router
  ) {
    super(route, commonService, dbOperationService, loadingState);
  }

  ngOnInit(): void {
    // ログイン判定
    this.isLogin = this.loginUser != null ? true : false;

    // 分科会イベント／お知らせ一覧を取得
    this.getNoticeList();

    // 主催/参加分科会一覧を取得
    this.getOrganizerSubcommittee()

    // 分科会一覧を取得を実施
    // 当年度取得
    let currentYear = new Date();
    currentYear.setMonth(currentYear.getMonth() - 3);
    this.currentYear = currentYear.getFullYear();
    // 現在の西暦から2021年までの分科会一覧を取得
    // 2022年までの分科会一覧を取得
    for (let i = currentYear.getFullYear(); 2022 <= i; i--) {
      // 分科会一覧検索
      this.getSubcommitteeDataList({ year: i });
    }
    // 2021-2018年度のタブを表示するために空データを追加
    let pushData = new Array();
    pushData["year"] = "2021-2018";
    this.subcommitteeDataList.push(pushData);
  }

  /**
   * 分科会一覧を取得
   */
  private getSubcommitteeDataList(searchConditions?: any): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(SUBCOMMITTEE_LIST);

    // 分科会一覧を取得
    this.dbOperationService
      .getNoTemplateData(SUBCOMMITTEE_LIST, searchConditions, true)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // 分科会一覧を格納
          let pushData = response.body;
          pushData["year"] = searchConditions.year;
          this.subcommitteeDataList.push(pushData);
        } else {
          // 結果がなければ空データを挿入
          let pushData = new Array();
          pushData["year"] = searchConditions.year;
          this.subcommitteeDataList.push(pushData);
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, SUBCOMMITTEE_LIST);
      });
  }

  /**
   * 分科会イベント／お知らせ一覧を取得
   */
  private getNoticeList(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(SUBCOMMITTEE_EVENT_NOTICE_LIST);

    // 分科会一覧を取得
    this.dbOperationService
      .getNoTemplateData(SUBCOMMITTEE_EVENT_NOTICE_LIST, null, false)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // 分科会一覧を格納;
          this.noticeList = response.body;
        } else {
          this.noticeList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, SUBCOMMITTEE_EVENT_NOTICE_LIST);
      });
  }

  /**
   * 主催/参加分科会一覧を取得
   */
  private getOrganizerSubcommittee() {
    // ログイン中か判定
    if (!this.decisionLoginState()) {
      // 未ログインであれば処理スキップ
      return;
    }

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(API_URL_ORGANIZER_SUBCOMMITTEE);

    // 会員主催イベント申請詳細を取得
    this.dbOperationService
      .getNoTemplateData(API_URL_ORGANIZER_SUBCOMMITTEE, { user_id: this.loginUser.user_id }, false)
      .subscribe((response) => {
        if (this.commonService.checkNoneResponse(response)) {
          this.loadingState.loadSleepEnd(0.3, API_URL_ORGANIZER_SUBCOMMITTEE);
          this.organizerSubcommitteeList = new Array();
        } else {
          this.organizerSubcommitteeList = response.body;
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, API_URL_ORGANIZER_SUBCOMMITTEE);
      });
  }

  /**
   * データソート
   * @param dataList: データリスト
   * @param column: ソートするカラム
   * @param descFlg: 降順フラグ
   * @param type: 型
   */
  public sortDataList(dataList: any, column: string, descFlg: boolean, type: string) {
    return dataList.sort(this.sortBy(column, descFlg, type));
  }

  /**
   * データソート処理
   * @param field: カラム名
   * @param reverse: ソート順
   * @param type: 型
   */
  public sortBy(field, reverse, type) {
    reverse = (reverse) ? -1 : 1;
    return function (a, b) {
      a = a[field];
      b = b[field];
      switch (type) {
        case "number":
          a = parseInt(a);
          b = parseInt(b);
          // 昇順
          if (a < b) return reverse * -1;
          // 降順
          if (a > b) return reverse * 1;
          break;
        case "date":
          // 昇順
          if (reverse == 1) return <any>new Date(a) - <any>new Date(b);
          // 降順
          if (reverse == -1) return <any>new Date(b) - <any>new Date(a);
        default:
          break;
      }
      return 0;
    }
  }

  /**
   * 分科会詳細(E202)へ遷移する
   * @param subcommitteeId 分科会ID
   */
  public moveE202(subcommitteeId: string): void {
    // 分科会詳細(E202)へ遷移
    this.router.navigate(['pages/platform/e202/' + subcommitteeId]);
  }

  /**
   * 作成日付の表示フォーマット変換
   * @param val 作成日付
   * @returns 10桁に変換した作成日付
   */
  public convCreatedate(val: string): string {
    return val.substring(0, 10) + " 登録";
  }

  /**
   * 会員主催イベント詳細(E102)へ遷移する
   * @param memberEventId 会員主催イベントID
   */
  public moveE102(memberEventId: string): void {
    // 会員主催イベント詳細(E102)へ遷移
    this.router.navigate(['pages/platform/e102/' + memberEventId]);
  }

  /**
   * マイページ(B301)へ遷移する
   */
  public moveB301(): void {
    // マイページ(B301)へ遷移
    this.router.navigate(['pages/platform/b301']);
  }
}
